export const CONFIG_LOAD = 'config/load';
export const CONFIG_SET = 'config/set';
export const CONFIG_SET_LOADING_ERROR = 'config/set-loading-error';
